/**
 * G13. Отказ: удержать «Не сегодня» 10 секунд. Сила тяги написана; при
 * силе выше порога кнопка уезжает и её надо поймать за 1,5 с. Блок
 * помощи рисует каркас (`heavy`).
 */
import { t } from '@life/i18n';
import { REFUSAL_ESCAPE_STRENGTH, REFUSAL_FAIL_URGE, REFUSAL_SUCCESS_URGE, type RefusalInput, type RefusalState } from '@life/minigames';
import type { MinigameScreenProps } from './types';
import { Hold } from './ui/Hold';

export function Refusal({ state, onInput }: MinigameScreenProps<RefusalInput, RefusalState>) {
  return (
    <>
      <p class="q-text">{t(`minigame.refusal.habit.${state.habit}`)}</p>
      <p class="hint">{t('ui.minigame.refusal.rules', { n: Math.round(state.strength), s: state.holdMs / 1000, ok: REFUSAL_SUCCESS_URGE, fail: REFUSAL_FAIL_URGE })}</p>
      {state.escapeAtMs !== null && <p class="hint">{t('ui.minigame.refusal.escape', { th: REFUSAL_ESCAPE_STRENGTH, s: state.catchMs / 1000 })}</p>}
      <Hold label={t('minigame.refusal.hold')} holdMs={state.holdMs} escapeAtMs={state.escapeAtMs} catchMs={state.catchMs} onDone={(r) => onInput(r)} />
    </>
  );
}
